import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

/**
 * Screen-reader-only. Used for the verification step's heading: that step is a progress
 * spinner with no visible heading of its own, but it still needs a focus target so the
 * step change is announced like the other two (see the step-focus effect in the component).
 */
export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export default css`
  .BaseModal-Content.popup {
    width: 560px;
  }

  &.ConfirmCardDetailsModal {
    .fields-row {
      > * {
        flex: 1;
      }
    }

    /* Reserves room for one line of field-level error text below the input, so the modal
     * doesn't resize/jump the moment an error appears after a failed Next click. */
    [data-testid$='-group'] {
      min-height: calc(52px + ${spacing(5)} + ${spacing(2)} + 16px);
    }
  }
`
